const registerType = {
  REGISTER_SET: 'REGISTER_SUCCESS',
  REGISTER_CLEAR_ERRORS: 'REGISTER_CLEAR_ERRORS',
};
export default registerType;
